<template> <!-- OK -->
  <div class="cadastro-container">
    <Register/>
  </div>
</template>


<script>
import Register from '../components/Register.vue';

export default {
  name: 'Cadastro',
  components: {
    Register
  }
}

</script>

<style scoped>

.cadastro-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(0deg, #3a67bf, #020094),
  linear-gradient(90deg, #3a67bf, #020094),
  linear-gradient(135deg, #3a67bf, #020094);
}

.cadastro-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 425px) {
  .cadastro-container {
    flex-direction: column;
  }
}


</style>